export default "__VITE_ASSET__CcNeOn64__"